import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { HubItemFacade } from '../hub-item.facade';
import { SecurityCheckFacade } from './security-check.facade';
import { switchMap } from 'rxjs/operators';
import { checkStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { SecurityCheckContextType } from '../../../../../constants/security-check.constant';

@Injectable({ providedIn: 'root' })
export class HubSecurityCheckGuard {
  constructor(private hubItemFacade: HubItemFacade, private hubSecurityCheckFacade: SecurityCheckFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    this.hubSecurityCheckFacade.setContextType(SecurityCheckContextType.Hub);

    return this.hubItemFacade.hubId$.pipe(
      switchMap((id: number) => {
        this.hubSecurityCheckFacade.setContextId(id);
        return checkStoreState(this.hubSecurityCheckFacade, id);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.hubSecurityCheckFacade);
  }
}
